/* eslint-disable */
import React, { useState, useEffect, useMemo } from 'react'
import moment from 'moment'
import { useSelector } from 'react-redux'
import DateRangeComp from '../../../components/daterange'
import DropdownComp from '../../../components/dropdown/dropdown'
import * as OkrPopUpConst from '../../constants/okrPopUp.constants'
import { WbUniqueIdMixin } from '../../../utils/common'
import * as Graph from '../../../utils/kr-graph'
import { imgUrl } from '../../../utils/url'
import ChartDataTable from '../../../components/chart-data-table'
import { krdetailConstants } from '../../../constants/krdetails.constants'
import { getIntervalOptions } from '../../../utils/metric'
import { useTranslation } from 'react-i18next'
import KrChartEnhanced from '../../../components/krDetails/KrChartEnhanced.component'
import { useEnhancedKrChartToggle, withChildMit } from '../../../components/krDetails/useEnhancedKrChartToggle'
const initialState = {
    interval: 0,
    graphAvailable: false,
    range: {
        start: 0,
        end: 0,
    },
    numberOfDataPoints: 0,
}

type PredictionData = {
    name: string
    color: string
    dashStyle: string
    lineWidth: number
    type: string
    counting: any
    childMIT: boolean
    marker: {
        symbol: string
        lineWidth: number
        enabled: boolean
        lineColor: any
    }
}

const Prediction: PredictionData = {
    name: '',
    color: '',
    dashStyle: '',
    lineWidth: null,
    type: '',
    counting: '',
    childMIT: null,
    marker: {
        symbol: '',
        lineWidth: null,
        enabled: false,
        lineColor: null // inherit from series
    }
}

const getLastTwoPoints = (series = []) => {
    if (series.length === 0) {
        return [null, null]
    }

    let last = [undefined, undefined]
    let beforeLast = [undefined, undefined]

    let i = series.length - 1
    while (series[i][1] == null) {
        i--
    }
    last = series[i]

    i-- // on to the before last
    while (series[i] && series[i][1] == null) {
        i--
    }
    beforeLast = series[i]

    return [last, beforeLast]
}

const OkrMetricGraph = (props: any) => {
    const {
        metrics,
        Goals,
        pageSource,
        surveyUserSelected,
        subGraphData,
        isEnabledBiweeklyKR = false,
        dataSource,
        isStretchEnabled = false
    } = props
    const { t } = useTranslation()
    const { source, mirrorSource } = metrics
    const sourceInt = parseInt(source)
    const mirrorSourceInt = parseInt(mirrorSource)
    const isMITKR = (sourceInt === krdetailConstants.SOURCE_MIT_PERSON
        || sourceInt === krdetailConstants.SOURCE_MIT_DATA_STREAMS || sourceInt === krdetailConstants.SOURCE_DISTINCT_KR
        || mirrorSourceInt === krdetailConstants.SOURCE_MIT_PERSON
        || mirrorSourceInt === krdetailConstants.SOURCE_MIT_DATA_STREAMS || mirrorSourceInt === krdetailConstants.SOURCE_DISTINCT_KR)
    const goalStartDate = new Date(props.Goals.start_date * 1000) // timestamp * 1000 for converting normal date
    const goalTargetDate = new Date(props.Goals.target_date * 1000) // timestamp * 1000 for converting normal date
    const isAnnualMit = Math.ceil(
        moment(new Date(goalTargetDate)).diff(moment(new Date(goalStartDate)), 'days', true)
    ) >= 360

    const [interval, setInterval] = useState(metrics.interval ? metrics.interval : 5)

    const [range, setRange] = useState({})

    // getting dataSource to display target date for each mit kr
    const krReducers = useSelector((state: any) => state.KrReducers)

    const getGraphOptions = () => {
        let options: any = {}
        if (typeof metrics.chart_data !== 'undefined') {
            const graphData = metrics.chart_data
            const chartHeight = 223
            const { start_date } = Goals
            const end_date = Goals.target_date
            const data_interval = metrics.interval
            const upd_data_interval = interval
            const target_label = 'Target'
            const target_color = '#cccccc'
            const kr_name = metrics.name
            const {
                graph_type,
                counting,
                target,
                achieve_target,
                progress_type,
                metric,
                source,
                weekly_update_day,
                quarter_target_type,
                mirrorChildMIT = false,
                quarter_name,
                achieve_target_without_word,
                measure_metric_data,
                stretch_target
            } = metrics
            options = {
                graph_type,
                isChildMit: mirrorChildMIT,
                keep_open: (pageSource == 'subGraph'),
                data_interval,
                goal_start_date: Goals.start_date,
                start_date,
                end_date,
                series: [],
                print_height: chartHeight * 0.8,
                pie_height: chartHeight * 0.8,
                target_color,
                target_label,
                counting,
                target,
                achieve_target: achieve_target_without_word,
                metric,
                quarter_target_type,
                progress_type,
                source,
                tooltip: [],
                weekly_update_day,
                upd_data_interval,
                orgConfigPeriod: graphData.orgConfigPeriod,
                showAttachment: true,
                mirrorSource,
                kr_name,
                isAnnualMit,
                childMitData: graphData.childMITData || [],
                isChildAnnualMit: !!quarter_name,
                orgPeriods: graphData.orgPeriods || [],
                measure_metric_data,
                stretch: stretch_target,
                isStretchEnabled
            }
            const k = metrics
            if (Object.keys(surveyUserSelected).length > 0) {
                k.series = subGraphData || {}
                options.tooltip = subGraphData.tooltip || []
            } else {
                k.series = graphData
                options.tooltip = graphData.tooltip
            }

            if (
                typeof k.series !== 'undefined'
                && k.series != null
                && ((typeof k.series.data !== 'undefined' && graph_type != OkrPopUpConst.CHART_TYPE.PIE_CHART)
                    || graph_type == OkrPopUpConst.CHART_TYPE.PIE_CHART)
            ) {
                const seriesData = k.series?.data || [];
                const _series = {
                    color: '#3BC1E5',
                    name: t('Actual'),
                    data: seriesData.map((s) => {
                        const yValue = s[1]
                        if (yValue != null) Number(yValue)
                        const qLabel = (typeof s.label !== 'undefined') ? s.label : null
                        return [Number(s[0]), yValue, Number(s.target), qLabel]
                    }),
                    type:
                        graph_type == OkrPopUpConst.CHART_TYPE.BAR_CHART || graph_type == OkrPopUpConst.CHART_TYPE.STACKED_BAR_CHART
                            ? 'column'
                            : 'area',
                    target: parseInt(k.target) || null,
                    lower_limit: parseInt(k.lower_limit) || null,
                    upper_limit: parseInt(k.upper_limit) || null,
                    counting: k.counting,
                    childMIT: k.cascade_goal_id == null && k.goal_id == null,
                    marker: {
                        symbol: 'circle',
                        // fillColor: "#f2f2f2",
                        enabled: true,
                        lineWidth: 2,
                        lineColor: null // inherit from series
                    },
                    upd_data_interval: 4
                }
                if (graph_type == OkrPopUpConst.CHART_TYPE.LINE_CHART) {
                    // _series.connectNulls = true;
                    _series.marker = {
                        symbol: 'circle',
                        // fillColor: "#f2f2f2",
                        enabled: true,
                        lineWidth: 2,
                        lineColor: null // inherit from series
                    }
                }
                options.series.push(_series)
                // console.log('_series -->', _series)
                if ((isMITKR || options.isChildMit) && (progress_type == 1 || progress_type == 3)) {
                    const _series2 = {
                        ..._series,
                        color: '#005270',
                        name: 'Target',
                        data: seriesData.map(s => {
                            let yValue = s.target
                            if (yValue != null) yValue = Number(yValue)
                            return [Number(s[0]), yValue]
                        }),
                        type: 'spline',
                        dashStyle: 'longdash',
                        marker: {
                            symbol: 'circle',
                            lineWidth: 2,
                            enabled: true,
                            lineColor: '#005270',
                            fillColor: 'white'
                        }
                    }
                    options.series.push(_series2)
                }

                const prediction = {
                    name: 'Prediction',
                    color: '#A5B3B7',
                    dashStyle: 'Dash',
                    lineWidth: 2,
                    type: 'line',
                    counting: k.counting,
                    childMIT: k.cascade_goal_id == null && k.goal_id == null,
                    marker: {
                        symbol: 'circle',
                        lineWidth: 2,
                        enabled: false,
                        lineColor: null // inherit from series
                    }
                }

                if (k.series.prediction) {
                    let predictedValue = 0
                    if (
                        (counting == '1' && k.series.prediction[1] > parseInt(options.target))
                        || (counting == '2' && k.series.prediction[1] < parseInt(options.target))
                    ) {
                        predictedValue = parseInt(options.target)
                    } else {
                        predictedValue = k.series.prediction[1]
                    }

                    const [lastPoint, beforeLastPoint] = getLastTwoPoints(_series.data)

                    let predictionStart = lastPoint

                    // if (this.state.shouldRegroup) {

                    // when chart type is being changed from DAILY -> WEEKLY in the UI,
                    // the grouping kicks in as per {dataGrouping: {enabled: true}}
                    // and the marker points are averaged automatically by Highcharts
                    // So the start of prediction line should match the new ending of the actual graph
                    // and arithmetic average is a good estimation
                    predictionStart = [
                        lastPoint[0],
                        (lastPoint[1] + beforeLastPoint[1]) / 2
                    ]
                    // }

                    // markers are disabled for prediction line, but we still need to show a marker at the end
                    const predictions = {
                        ...prediction,
                        data: [{
                            x: predictionStart[0],
                            y: predictionStart[1],
                        }, {
                            x: k.series.prediction[0] * 1000,
                            y: predictedValue,
                            marker: {
                                enabled: true,
                            },
                        }
                        ]
                    }

                    // options.series.push(predictions); // we don't want to show prediction in OKR popup
                }
            } else if (graph_type != OkrPopUpConst.CHART_TYPE.PIE_CHART) {
                const dummy = []
                dummy.push(parseInt(start_date) * 1000)
                dummy.push(null)
                options.series.push({
                    color: '#3BC1E5',
                    data: [dummy],
                    type: graph_type == OkrPopUpConst.CHART_TYPE.PIE_CHART ? 'column' : 'line'
                })
            }
        }
        return options
    }

    const krGraphId = `kr_det_graph1_${metrics.id}`
    const surveyUserSelectedUser = (surveyUserSelected && surveyUserSelected.user_id) || ''
    const getIntervalData = (isBiweeklyKREnabled = false) => {
        if (typeof metrics != 'undefined' && metrics.interval != null) {
            let addOnce = 'default'
            if (((metrics.source == OkrPopUpConst.metricdetailConstants.SOURCE_MIRROR_KR
                || metrics.source == OkrPopUpConst.METRIC_SOURCE.SOURCE_SURVEY)
                && (metrics.counting == OkrPopUpConst.METRIC_COUNTING.METRIC_COUNTING_SURVEY_YES_NO
                    || metrics.counting == OkrPopUpConst.METRIC_COUNTING.METRIC_COUNTING_SURVEY_SCALE))) {
                addOnce = 'cascade'
            }
            const intervalValue = metrics.interval
            const intervalData = [...getIntervalOptions(addOnce, isBiweeklyKREnabled, false, intervalValue === krdetailConstants.INTERVAL_BIQUARTERLY)]
            if (intervalValue == OkrPopUpConst.metricdetailConstants.INTERVAL_BIWEEKLY) {
                const biweeklyIntervals = [OkrPopUpConst.metricdetailConstants.INTERVAL_BIWEEKLY,
                OkrPopUpConst.metricdetailConstants.INTERVAL_MONTH,
                OkrPopUpConst.metricdetailConstants.INTERVAL_QUARTER
                ]
                return intervalData.filter(f => biweeklyIntervals.includes(f.value))
            } if (
                intervalValue != OkrPopUpConst.metricdetailConstants.INTERVAL_BIWEEKLY
                && intervalValue >= OkrPopUpConst.metricdetailConstants.INTERVAL_MONTH
                && isBiweeklyKREnabled
            ) {
                return intervalData.filter(
                    f => f.value >= intervalValue && f.value != OkrPopUpConst.metricdetailConstants.INTERVAL_BIWEEKLY
                )
            }
            if (intervalValue == OkrPopUpConst.metricdetailConstants.INTERVAL_ONCE) {
                return intervalData.filter(f => f.value == intervalValue)
            }
            return intervalData.filter(f => f.value >= intervalValue)
        }
    }

    const handleIntervalChange = (e: any, item: any) => {
        setInterval(item.value)
    }
    const loadGraphTable = (id) => {
        const options = getGraphOptions()
        Graph.drawMetricCharts(id, range, options, surveyUserSelectedUser, pageSource, { table: true, chart: false })
    }
    useEffect(() => {
        const options = getGraphOptions()
        Graph.drawMetricCharts(krGraphId, range, options, '', pageSource)
    }, [interval])

    const onClearDateRange = (ele: any, prop: any) => {
        setRange({})
        const options = getGraphOptions()
        Graph.drawMetricCharts(krGraphId, {}, options, '', pageSource)
    }

    // trigger when update date picker on <DateRangeComp />
    const onChangeDateRange = (ele: any, rang: any, prop: any) => {
        // console.log("rang -->", rang);
        setRange(rang)
        const options = getGraphOptions()
        Graph.drawMetricCharts(krGraphId, rang, options, '', pageSource)
    }

    const intervalData = getIntervalData(isEnabledBiweeklyKR)
    // const startDateString = (range && range.start && moment.utc(this.state.range.start)._d.getTime() / 1000) ||
    // (Goals && Goals.start_date);
    // const endDateString = (range && range.end && moment.utc(this.state.range.end)._d.getTime() / 1000) ||
    // (Goals && Goals.target_date);

    useEffect(() => {
        // console.log(props, "in graph props");
        if ($(`#${krGraphId}`).length) {
            const options = getGraphOptions()
            Graph.drawMetricCharts(krGraphId, range, options, surveyUserSelectedUser, pageSource)
        }
    }, [props])

    useEffect(() => {
        let { interval } = metrics
        if (isAnnualMit && isMITKR) {
            interval = krdetailConstants.INTERVAL_QUARTER
        }
        setInterval(interval || 5)
    }, [metrics.id, isMITKR, isAnnualMit])

    const krGraphStyle: any = {}
    if (pageSource == 'subGraph') {
        krGraphStyle.width = 'calc(100% - 150px)'
    }
    return (
        <div className="okr-metric-graph">
            {isStretchEnabled && metrics.counting != 4 && metrics.target && metrics.stretch_target !== null && (metrics.source != OkrPopUpConst.metricdetailConstants.SOURCE_OTHER_GOALS &&
                metrics.source != OkrPopUpConst.metricdetailConstants.SOURCE_MIT_PERSON &&
                metrics.source != OkrPopUpConst.metricdetailConstants.SOURCE_MIT_DATA_STREAMS &&
                metrics.source != OkrPopUpConst.metricdetailConstants.SOURCE_MIT_PERSON_DISTINCT) && (
                    <div className="graph-target-legend">
                        <span className="commit-target-block">
                            <img src={`${wbConfig.imageCdnUrl}/images/goal/metric/committedTarget.png`} />Committed Target
                        </span>
                        <span className="stretch-target-block">
                            <img src={`${wbConfig.imageCdnUrl}/images/goal/metric/stretchTarget.png`} /> Stretch Target
                        </span>
                    </div>
                )}
            {
                (metrics.source != OkrPopUpConst.metricdetailConstants.SOURCE_OTHER_GOALS
                    && metrics.mirrorSource != OkrPopUpConst.metricdetailConstants.SOURCE_OTHER_GOALS)
                && (
                    <div className="goal-chart-date-range-section">
                        {
                            <DateRangeComp
                                key={WbUniqueIdMixin.randomId(`kr_det_date_range_${metrics.id}`)}
                                id={`kr-det-daterange1-${metrics.id}`}
                                start_date={metrics?.start_date ?? Goals.start_date}
                                // start_date_string={startDateString}
                                end_date={metrics?.end_date ?? Goals.target_date}
                                // end_date_string={endDateString}
                                onChange={onChangeDateRange}
                                onClear={onClearDateRange}
                                construnctSeriesOptions={getGraphOptions}
                                item={metrics}
                            />
                        }
                        {
                            // 16916
                            (metrics.source != OkrPopUpConst.METRIC_SOURCE.SOURCE_MIT_DATA_STREAMS && interval !== 5)
                            && (
                                <div className="kr-det-chart-daterange displayInlBlk valignMiddle">
                                    <DropdownComp
                                        key={`kr_dp_id_${metrics.id}`}
                                        options={intervalData}
                                        defaultValue={interval}
                                        onChange={handleIntervalChange}
                                        wrapperClass="graph-day-intervals"
                                        optionsClass="kr-graph-dropdwn-options"
                                        appendId="okr-metric-graph"
                                    />
                                </div>
                            )
                        }
                    </div>
                )
            }
            <div className="chartTableIcon">
                <ChartDataTable graphHandler={loadGraphTable}> </ChartDataTable>
            </div>
            <div id={krGraphId} className={"kr-det-graph" + ((metrics.graph_type == OkrPopUpConst.CHART_TYPE.LINE_CHART || metrics.graph_type == OkrPopUpConst.CHART_TYPE.PIE_CHART) ? " lineChart" : " barChart")} style={krGraphStyle} />
            {
                metrics.counting == OkrPopUpConst.metricdetailConstants.METRIC_COUNTING_SURVEY_YES_NO
                && metrics.chart_data
                && (
                    <div className="displayTable stackBarlegendSec">
                        <div className="displayRow ">
                            <div className="displayCell legendHead">
                                <div className="yesLegend" />
                            </div>
                            <div className="displayCell legendText">
                                {t('Yes')}
                            </div>
                            <div className="displayCell legendHead">
                                <div className="noLegend" />
                            </div>
                            <div className="displayCell legendText">
                                {t('No')}
                            </div>
                            <div className="displayCell legendHead">
                                <div className="noresponseLegend" />
                            </div>
                            <div className="displayCell">
                                {t('No response')}
                            </div>
                        </div>
                    </div>
                )
            }

            {
                metrics.graph_type == OkrPopUpConst.CHART_TYPE.PIE_CHART
                && metrics.chart_data == undefined
                && metrics.chart_data == ''
                && (
                    <div className="empty-chart empty-piechart" data-type={metrics.graph_type}>
                        <img
                            alt="Goal chart empty"
                            src={imgUrl('/images/goal/goal_chart_empty.png')}
                            style={{ width: '120px' }}
                        />
                        <br />
                        <span style={{ display: 'block' }}>{t('There is no data to display on this chart yet')}</span>
                        {
                            (metrics.canEditMetric
                                && metrics.source == OkrPopUpConst.metricdetailConstants.SOURCE_PERSON)
                            && (
                                <span className="update-metric-link" style={{ margin: '0px 40%;' }}>
                                    <a
                                        href="javascript://"
                                        className="openEditMetricData addmetric-data-link"
                                        metric-id={metrics.id}
                                    >
                                        {t('Update your data now.')}
                                    </a>
                                </span>
                            )
                        }
                    </div>
                )
            }
            {
                metrics.chart_data == undefined && metrics.chart_data == ''
                && (
                    <div className="empty-chart empty-linechart" data-type={metrics.graph_type}>
                        <img
                            alt="Goal chart empty"
                            src={imgUrl('/images/goal/goal_chart_empty.png')}
                            style={{ width: '120px' }}
                        />
                        <br />
                        <span style={{ display: 'block' }}>{t('There is no data to display on this chart yet')}</span>

                        {
                            metrics.canEditMetric
                            && metrics.source == OkrPopUpConst.metricdetailConstants.SOURCE_PERSON
                            && (
                                <span className="update-metric-link" style={{ margin: '0px 40%' }}>
                                    <a
                                        href="javascript://"
                                        className="openEditMetricData addmetric-data-link"
                                        metric-id={metrics.id}
                                    >
                                        {t('Update your data now.')}
                                    </a>
                                </span>
                            )
                        }
                    </div>
                )
            }

        </div>

    )
}

const OkrMetricGraphSwitch = (props: any) => {
    const { metrics, Goals, refreshKey = 0 } = props
    const metric = useMemo(() => withChildMit(metrics), [metrics])
    const { showEnhancedKrChart } = useEnhancedKrChartToggle(metric)
    return showEnhancedKrChart
        ? <KrChartEnhanced key={metric.id} refreshKey={refreshKey} KrReducers={{ metric, goal: Goals }} hideKrInfo />
        : <OkrMetricGraph {...props} />
}

export default OkrMetricGraphSwitch
